import { SvgIconProps } from './icon-props';

export default function ChevronRight({ height = 180, width = 99, className }: SvgIconProps) {
	return (
		<svg
			width={width}
			height={height}
			data-name="Layer 1"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 99 180"
			className={className}
		>
			<path fillRule="evenodd" d="m0 180 90-81 9-9-9-9L0 0v18l81 72-81 72v18z" />
		</svg>
	);
}
